<template>
  <div class="law">
    <el-container>
      <el-header style="height: 100px">
        <Head></Head>
      </el-header>
      <el-main class="law_body">
        <div class="law" style="margin-top: 105px">
          <h1>奇迹ip用户服务协议</h1>
          <div class="lawTab">
            <h3>协议最新更新时间：2025年01月14日</h3>
            <h3>协议生效日期： 2025年01月14日</h3>
            <div class="paneContent">
              <div class="detail-box">
                <p>
                  奇迹ip用户服务协议是用户（“您”）与奇迹ip网络科技有限公司（以下简称为"奇迹ip"或“我们”）之间就奇迹ip的官方网站（apiupss.ppfly.top， “本网站”）服务等相关事宜所签订的合同，
                  <span class="blod"
                    >请您仔细阅读，若您通过勾选、点击确认或以其他方式表示接受本协议，或您以任何方式使用奇迹ip服务的，即视为您已充分阅读、理解并同意接受本协议的约束，同时本协议即在您与奇迹ip之间产生法律效力。</span
                  >
                </p>
                <div class="tit">第一条 总则</div>
                <p>
                  1.1
                  您在使用本服务之前，已经充分阅读、理解并接受本服务条款的全部内容（尤其是突出显示的内容），一旦您选择“同意”并完成账号注册或使用本服务，即表示您同意遵循本服务条款之所有约定。您使用奇迹ip服务的行为将被视为对本协议及《奇迹ip隐私协议》全部内容的认可。
                </p>
                <br />
                <p>
                  1.2
                  您同意：奇迹ip保留随时更新本协议即相应服务规则内容的权利。如果奇迹ip更新了本附录，奇迹ip将通过发布官网公告的形式通知您。如您不同意更改，则您有权在新的协议或服务规则生效日期之前终止使用本服务。若您在新的协议或服务规则生效日期之后继续使用本服务视为接受新的协议或服务规则并放弃根据本条终止服务的权利。
                </p>
                <br />
                <p>
                  1.3
                  在您完成账号注册或以其他奇迹ip允许的方式实际使用本服务时，您应当是具备完全民事权利能力和完全民事行为能力法律主体。若您不具备前述与您行为相适应的民事行为能力，则应获得法定监护人的知情同意。如您尚未成年，请在法定监护人的陪同下阅读和判断是否同意本协议。未成年人行使和履行本协议项下的权利和义务视为已获得法定监护人的认可。
                </p>
                <br />
                <div class="tit">第二条 协议的范围</div>
                <p>
                  2.1
                  本协议是用户与奇迹ip之间关于使用奇迹ip的服务所订立的协议。“奇迹ip”是指奇迹ip和/或其相关服务可能存在的运营关联单位。“用户”是指奇迹ip的服务的使用人/使用企业（包括但不限于注册用户、免费用户，第三方渠道登录用户及合作伙伴、代理商所属用户），在本协议中更多地称为“您”。
                </p>
                <br />
                <p>
                  2.2
                  奇迹ip的服务是指奇迹ip向您提供的，具体服务以奇迹ip实际提供的为准（以下简称“本服务”）。
                </p>
                <br />
                <p>
                  2.3 本协议内容同时包括《奇迹ip隐私协议》，且您在使用奇迹ip某一特定服务时，该服务可能会另有单独的协议、相关业务规则等（以下统称为“单独协议”）。上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守。您对前述任何单独协议的接受，即视为您对本协议全部的接受。您对本协议的接受，即视为您对《奇迹ip隐私协议》的接受。
                </p>
                <br />
                <p>2.4 奇迹ip仅对本服务条款中列明的责任承担范围负责。</p>
                <br />
                <p>
                  2.5
                  奇迹ip对于因本服务条款有关或由本服务条款引起的违约、侵权等导致的任何间接的、惩罚性的、特殊的、派生的损失（包括业务损失、收益损失、利润损失、使用数据、商誉或其他经济利益的损失），不论是如何产生的，均不承担任何责任，即使事先已被告知可能发生此等损失。
                </p>
                <br />
                <div class="tit">第三条 账号与密码安全</div>
                <p>
                  3.1
                  为使用奇迹ip服务，您需要注册奇迹ip账号（以下简称“账号”）。在您按照注册页面提示填写信息、阅读并同意本服务条款且完成注册后，或您以其他奇迹ip允许的方式实际使用本网站服务时，您即受本服务条款约束。
                </p>
                <br />
                <p>
                  3.2
                  您应依法具备必要、适当的权利能力和行为能力，已授予操作人足够的权利完成注册过程。您承诺提供的注册资料真实、准确、完整、合法有效，您的注册资料如有变动的，应及时更新注册资料。您应对注册获得的奇迹ip账号项下的一切行为承担全部责任，不得侵犯包括但不限于奇迹ip在内的任何主体的合法权益。
                </p>
                <br />
                <p>
                  3.3
                  您了解并同意：为保证账户和交易安全，奇迹ip有权随时要求您完成奇迹ip账户的实名认证；您的账户只有在通过这些认证和验证之后，才能获得使用奇迹ip相关服务的资格。
                </p>
                <br />
                <p>
                  3.4
                  您同意或接受：在必要地情况下，我们有权使用您的注册信息、用户名、密码等信息，登录进入您的注册账户，进行证据保全，包括但不限于公证、见证等。
                </p>
                <br />
                <p>
                  3.5
                  奇迹ip账号仅限于您自身使用，未经奇迹ip同意，您不得将账号以任何方式提供给他人使用。您应为账号下的行为负责，账号下的所有操作行为均被视为您实施，且应由您承担全部法律后果。
                </p>
                <br />
                <p>
                  3.6
                  奇迹ip特别提醒您应妥善保管您的帐号和密码。当您使用完毕后，应安全退出。因您保管不善可能导致遭受被盗号或密码失窃，责任由您自行承担。
                </p>
                <br />
                <div class="tit">第四条 隐私及其他用户个人信息的保护</div>
                <p>
                  4.1
                  保护用户个人信息是奇迹ip的一项基本原则。奇迹ip将按照本协议及《奇迹ip隐私协议》的规定收集、使用、储存您的个人信息。本协议对个人信息保护相关内容未作明确规定的，均应以《奇迹ip隐私协议》的内容为准。
                </p>
                <br />
                <p>
                  4.2
                  您在注册帐号或使用本服务的过程中，需要填写一些必要的信息（手机号或身份信息）。根据国家法律法规规定，您需要填写真实的身份信息。若您填写的信息不完整，则可能无法使用本服务或在使用过程中受到限制。
                </p>
                <br />
                <p>
                  4.3
                  一般情况下，您可根据相关产品规则浏览、修改自己提交的信息，但出于安全性和身份识别的考虑，您无法修改实名认证信息。
                </p>
                <br />
                <p>
                  4.4 奇迹ip承诺会根据《奇迹ip隐私协议》对您资料采取对外保密措施，不向第三方披露您资料，不授权第三方使用您资料，除非：<br />
                  （1）依据本用户协议或者您与奇迹ip之间其他文件规定可以提供；<br />
                  （2）依据法律法规的规定应当提供；<br />
                  （3）行政、司法以及其他国家有关部门要求奇迹ip提供；<br />
                  （4）您同意奇迹ip向第三方提供；<br />
                  （5）奇迹ip解决举报事件、提起诉讼而提交的；<br />
                  （6）奇迹ip为防止违法违规、犯罪行为的发生而采取必要合理措施所必须提交的；<br />
                  （7）奇迹ip为向您提供产品、服务、信息而向第三方提供的，包括奇迹ip通过第三方的技术及服务向您提供产品、服务、信息的情况。
                </p>
                <br />
                <p>
                  4.5
                  奇迹ip仅按已有技术提供相应的安全措施来使奇迹ip管理的信息不丢失，但奇迹ip不承诺保证这些信息的绝对安全。
                </p>
                <br />
                <p>
                  4.6
                  您同意：为了更好地为您提供服务，我们可能会在您提供信息地基础上，不定期地通过邮件、短信、电话等形式，向您发送订单信息、促销活动等，同时保障您被告知信息的权利。
                </p>
                <div class="tit">第五条 服务</div>
                <p>
                  <span class="limit_tit">5.1 使用本服务的方式</span><br />
                  5.1.1 您依本协议条款所取得的权利仅您本人享有，不可转让。<br />
                  5.1.2
                  您不得使用任何方式（包括但不限于第三方软件、插件、系统、设备等）对本服务进行干扰、破坏、修改或施加其他影响。<br />
                  5.1.3 您应当通过奇迹ip提供或认可的方式使用本服务。<br />
                  5.1.4
                  您应当理解，您使用本服务需自行准备与相关服务有关的终端设备（如电脑、移动终端和必要的网络接入设备等装置），并承担所需的费用（如电话费、上网费等费用）。<br />
                  5.1.5
                  您理解并同意，您使用本服务时会耗用您的终端设备和带宽等资源。<br />
                </p>
                <br />
                <p>
                  <span class="limit_tit">5.2 服务费用</span><br />
                  5.2.1
                  奇迹ip可能根据实际需要对收费服务的收费标准、方式进行修改和变更，奇迹ip也可能会对部分免费服务开始收费。前述修改、变更或开始收费前，奇迹ip将在官网进行通知或公告。如果您不同意上述修改、变更或付费内容，则应停止使用该服务。<br />
                  5.2.2
                  在奇迹ip降低收费服务的收费标准或者将收费服务改为免费服务提供时，奇迹ip保留不对原付费用户提供退费或者费用调整之权利。<br />
                  5.2.3
                  您知晓并同意，发生如下情形之一的，奇迹ip将对您名下账户资金进行部分或全部冻结：<br />
                  （1）国家法律、政策法规、生效法律文书的规定；<br />
                  （2）有关国家主管部门要求进行冻结的；<br />
                  （3）您使用奇迹ip服务的行为涉嫌违反国家法律法规的；<br />
                  （4）您遭到他人投诉，且对方已经提供了初步证据，以至于奇迹ip有理由相信该投诉事项存在的；<br />
                  （5）奇迹ip根据自行合理判断，认为可能产生风险的其他情况。<br />
                </p>
                <br />
                <p>
                  <span class="limit_tit">5.3 按现状提供服务</span><br />
                  您理解并同意：<br />
                  （1）本服务是按照现有技术和条件所能达到的现状提供的。奇迹ip会尽最大努力保障服务的连贯性和安全性，但奇迹ip不能随时预见和防范法律、技术以及其他风险，奇迹ip对此类风险在法律允许的范围内免责，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。<br />
                  （2）奇迹ip可能根据经营策略或其他发展需求做产品或服务调整，不同地区的用户可使用的具体奇迹ip服务的内容可能会存在差异，具体以奇迹ip实际提供的为准。<br />
                  （3）奇迹ip服务价格、数量、是否有货等信息随时都有可能发生变动，我们将不会对此作特别通知。我们会尽最大努力保证您在奇迹ip官方网页所浏览信息的准确性，但由于众所周知的互联网技术因素等客观原因存在，奇迹ip官方网页显示的信息可能会有一定的滞后性或差错，对此情形您知悉并理解，并在使用奇迹ip服务时以实际情况为准。<br />
                  （4）除非另有明确的书面说明,我们提供给您的全部信息、内容、材料、产品或服务，均是在"按现状"和"按现有"的基础上提供的。除非另有明确的书面说明，我们不对本网站的运营及其包含在本网站上的信息、内容、材料、产品或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。<br />
                  （5）我们不担保本网站所包含的或以其它方式通过本网站提供给您的全部信息、内容、材料、产品和服务、其服务器或从本站发出的电子信件、信息没有病毒或其他有害成分。如因不可抗力或其它本站无法控制的原因使本站销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，我们会合理地尽力协助处理善后事宜。
                </p>
                <br />
                <p>
                  <span class="limit_tit">5.4 服务中止、变更、终止</span><br />
                  5.4.1
                  您理解并同意，为了向您提供更加完善的服务，奇迹ip可能会进行例行、有计划的维护，可能导致您所使用服务短时间的中断或暂停，且基于经营策略的调整，可能会对服务内容进行变更，同样可能会导致服务中断或终止，对于此类维护导致的服务中断或暂停，奇迹ip无需向您承担任何责任。<br />
                  5.4.2
                  奇迹ip有权按本协议约定进行收费。若您未按时足额付费，奇迹ip有权中断、中止或终止提供服务。<br />
                  5.4.3
                  您有责任自行备份存储在本服务中的数据。如果您的服务被终止，奇迹ip有权从服务器上永久地封存您的数据，法律法规另有规定的除外。服务中止或终止后，奇迹ip没有义务向您提供或返还数据。<br />
                  5.4.4
                  在奇迹ip发生合并、分立、收购、资产转让时，奇迹ip可向第三方转让本服务下相关资产；奇迹ip也可在单方通知您后，将本协议下部分或全部服务及相应的权利义务转交由第三方运营或履行。具体受让主体以奇迹ip的通知为准。<br />
                  5.4.5
                  如发生下列任何一种情形，奇迹ip有权不经通知而中断或终止向您提供服务：<br />
                  （1）根据法律法规规定您应提交真实信息，而您提供的个人资料不真实、或与注册时信息不一致又未能提供合理证明；<br />
                  （2）您违反相关法律法规的规定或违反本协议的约定；<br />
                  （3）按照法律法规规定，因执行法院、政府机构、司法机关等有权机关指令所需；<br />
                  （4）为处理奇迹ip服务安全性或完整性之紧急事件或其他必要的情形。
                </p>
                <div class="tit">第六条 第三方提供的产品或服务</div>
                <p>
                  若您通过奇迹ip网站获取、使用第三方提供的产品或服务，此时第三方产品和服务的运营方与您建立相应的服务关系，并向您承担产品和服务的责任。奇迹ip根据服务规则约定仅在自身责任范围内向您承担相应责任。
                </p>
                <div class="tit">第七条 用户违法违规行为</div>
                <p>
                  7.1
                  您在使用本服务时须遵守法律法规，不得制作、复制、发布、传播含有下列内容的信息或从事相关行为，也不得为制作、复制、发布、传播含有下列内容的信息或从事相关行为提供便利：<br />
                  （1）反对宪法所确定的基本原则的；<br />
                  （2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br />
                  （3）损害国家荣誉和利益的；<br />
                  （4）煽动民族仇恨、民族歧视，破坏民族团结的；<br />
                  （5）破坏国家宗教政策，宣扬邪教和封建迷信的；<br />
                  （6）散布谣言，扰乱社会秩序，破坏社会稳定的；<br />
                  （7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br />
                  （8）侮辱或者诽谤他人，侵害他人合法权益的；<br />
                  （9）违反法律法规底线、社会主义制度底线、国家利益底线、公民合法权益底线、社会公共秩序底线、道德风尚底线和信息真实性底线的“七条底线”要求的；<br />
                  （10）相关法律法规或本协议、相关协议、规则等禁止的。<br />
                </p>
                <br />
                <p>
                  7.2
                  如果您在使用本服务过程中违反了相关法律法规或本协议约定，相关国家机关或机构可能会对您提起诉讼、罚款或采取其他制裁措施，并要求奇迹ip给予协助。因此给您或者他人造成损害的，您应自行承担全部责任，奇迹ip不承担任何责任。
                </p>
                <br />
                <p>
                  7.3
                  如果您违反本协议约定，奇迹ip有权进行独立判断并采取相应措施。同时，奇迹ip有权视您的行为性质，采取包括但不限于暂停或终止向您提供服务，限制、中止、冻结或终止您对帐号使用，追究法律责任等措施。
                </p>
                <br />
                <p>
                  7.4
                  您违反本协议约定，导致任何主体损失的，您应当独立承担责任；奇迹ip因此遭受损失的，您也应当一并赔偿。
                </p>
                <br />
                <p>
                  7.5
                  您须对自己在网上的言论和行为承担法律责任，您若在本网站上散布和传播反动、色情或其它违反国家法律的信息，本网站的系统记录有可能作为您违反法律的证据。
                </p>
                <div class="tit">第八条 知识产权</div>
                <p>
                  8.1
                  奇迹ip在本服务中提供的内容（包括但不限于网页、文字、图片等）的知识产权归奇迹ip所有，您在使用本服务中所产生内容的知识产权归您或相关权利人所有，除非您与奇迹ip另有约定。
                </p>
                <br />
                <p>
                  8.2
                  除另有特别声明外，奇迹ip提供本服务时所依托的著作权、专利权及其他知识产权均归奇迹ip所有。
                </p>
                <br />
                <p>
                  8.3
                  奇迹ip在本服务中所使用的“奇迹ip”、logo等商业标识，其著作权或商标权归奇迹ip所有。
                </p>
                <br />
                <p>
                  8.4
                  上述及其他任何本服务包含的内容的知识产权均受到法律法规保护，未经奇迹ip、您或相关权利人书面许可，任何人不得以任何形式进行使用或创造相关衍生作品。
                </p>
                <br />
                <p>
                  8.5
                  尊重知识产权是您应尽的义务，如有违反，您应承担损害赔偿责任。
                </p>
                <div class="tit">第九条 不可抗力及免责</div>
                <p>
                  9.1
                  不可抗力指协议各方所不能预见、或为各方所不能克服、不能避免的客观情况，包括但不限于：<br />
                  9.1.1 自然灾害：如洪水、冰雹、海啸、台风、旱灾、火灾等；<br />
                  9.1.2
                  政府行为：如政府当局颁布或调整、变更的政策、法律、法规和采取新的行为措施等导致协议不能履行；<br />
                  9.1.3
                  社会异常现象：如骚乱、疾病、战争、罢工（但不包括各方内部劳资纠纷）等；其他不能预见、不能克服并不能避免且对一方或各方造成重大影响的事件。<br />
                  出现上述情况时，奇迹ip将及时与有关部门配合，争取尽快进行处理，但是由此给您造成的损失，奇迹ip在法律允许的范围内免责。
                </p>
                <br />
                <p>
                  9.2
                  因不可抗力导致任何一方（“受影响方”）无法履行本协议下的全部或部分义务，不视为受影响方违约，受影响方不承担因不可抗力导致的未履行或迟延履行本协议义务导致相对方遭受的任何损害、损失、或增加之费用。
                </p>
                <br />
                <p>
                  9.3 您理解并同意，鉴于互联网产品服务的特性，
                  在法律允许的范围内，奇迹ip对以下情形导致的服务异常不承担责任：<br />
                  （1）受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏、电信部门技术调整或故障等原因而造成的服务中断或者延迟；<br />
                  （2）您管理维护的软件、硬件设备、系统、通信线路出现故障，导致奇迹ip服务不能正常使用和造成其他衍生损害；<br />
                  （3）您操作不当、错误操作或您通过非奇迹ip授权的方式使用本服务；<br />
                  （4）程序版本过时、设备的老化和/或其兼容性问题；<br />
                  （5）其他非奇迹ip过错所导致的、奇迹ip无法控制或合理预见的情形。<br />
                </p>
                <div class="tit">第十条 遵守当地法律监管</div>
                <p>
                  10.1
                  您在使用本服务过程中应当遵守当地相关的法律法规，并尊重当地的道德和风俗习惯。如果您的行为违反了当地法律法规或道德风俗，您应当为此独立承担责任。
                </p>
                <br />
                <p>
                  10.2
                  您应避免因使用本服务而使奇迹ip违反法律法规或卷入政治和公共事件，否则奇迹ip有权暂停或终止对您的服务。
                </p>
                <br />
                <div class="tit">第十一条 您发送、传播的内容与投诉处理</div>
                <p>
                  11.1
                  您通过本服务发送或传播的内容（包括但不限于网页、文字、图片、音频、视频、图表等）均由您自行承担责任。
                </p>
                <br />
                <p>
                  11.2
                  如果您发送或传播的内容违法违规或侵犯他人权利的，奇迹ip有权进行独立判断并采取包括但不限于暂停或终止向您提供服务，限制、中止、冻结或终止您对帐号使用。
                </p>
                <br />
                <p>
                  11.3
                  如您被他人投诉或您投诉他人，奇迹ip有权将争议中相关方的主体信息、联系方式、投诉相关内容等必要信息提供给相关当事方或相关部门，以便及时解决投诉纠纷，保护各方合法权益。
                </p>
                <br />
                <p>
                  11.4
                  您保证对您在投诉处理程序中提供的信息、材料、证据等的真实性、合法性、有效性负责。
                </p>
                <div class="tit">第十二条 通知送达</div>
                <p>
                  12.1
                  您理解并同意，奇迹ip可依据自行判断，通过网页公告、电子邮件、手机短信或常规的信件传送等方式向您发出通知，且您确保您所提供的联系信息是完整、准确且当前有效的，上述通知于发送之日视为已送达收件人。如发生变更，需以各种奇迹ip提供的方式及时向奇迹ip提供变更后的信息，奇迹ip向您提供的联系信息发送通知后即视为送达，而无论该联系信息事实上是否由您本人继续使用。
                </p>
                <br />
                <p>
                  12.2
                  您应当通过奇迹ip对外正式公布的通信邮寄地址、传真号码、电子邮件地址、QQ、微信等即时通讯方式或其他联系信息进行送达您给奇迹ip发送的通知。
                </p>
                <br />
                <div class="tit">第十三条 协议的生效与变更</div>
                <p>
                  13.1 您使用本服务即视为您已阅读本协议、《奇迹ip隐私协议》,并接受本协议、《奇迹ip隐私协议》的约束。
                </p>
                <br />
                <p>
                  13.2
                  奇迹ip保留对本协议条款的修改权，修改后将会在官网发布或通过您预留的联系方式向您发送通知。您可以在相关服务页面查阅最新版本的协议条款。
                </p>
                <br />
                <p>
                  13.2
                  奇迹ip保留对本协议条款的修改权，修改后将会在官网发布或通过您预留的联系方式向您发送通知。您可以在相关服务页面查阅最新版本的协议条款。
                </p>
                <br />
                <div class="tit">第十四条 法律适用与管辖</div>
                <p>14.1 本协议的签订地为中华人民共和国江苏省徐州市泉山区。</p>
                <br />
                <p>
                  14.2
                  本服务条款之效力、解释、变更、执行与争议解决均适用中华人民共和国法律（不包括冲突法）。
                </p>
                <br />
                <p>
                  14.3
                  因本服务条款产生之争议，双方应首先协商解决；双方未能协商解决的，任何一方均可向本合同签订地江苏省徐州市泉山区人民法院提起诉讼。
                </p>
                <br />
                <p>
                  14.4
                  本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。
                </p>
                <br />
                <p>
                  14.5
                  本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。
                </p>
                <br />
                <div class="tit">第十五条 其他</div>
                <p>
                  如果您对本协议或本服务有意见或建议，可以随时与我们联系，我们会给予您必要的帮助。企业邮箱：service@奇迹ip.net
                </p>
                <br />
              </div>
            </div>
          </div>
        </div>
      </el-main>
      <Footer></Footer>
    </el-container>
  </div>
</template>
  <script>
import Head from "@/components/head/head.vue";
import Footer from "@/components/footer/footer.vue";
export default {
  components: { Head, Footer },
  name: "law",
  data() {
    return {};
  },
  methods: {
    totop() {
      // 滚动到顶部的逻辑
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
  created() {},
  mounted() {
    this.totop()
  },
};
</script>
  <style lang="scss" scoped>
.law {
  padding-bottom: 1rem;
  color: #444a6d;
}
.law h1 {
  width: 100%;
  text-align: center;
  font-size: 40px;
  font-family: SourceHanSansCN-Medium;
  font-weight: 600;
  //   margin: 180px 0 0;
  color: #18181b;
}
.law .lawTab {
  max-width: 965px;
  margin: 40px auto 0;
}
.law .lawTab h3 {
  font-size: 21px;
  line-height: 30px;
  color: #18181b;
  font-family: SourceHanSansCN-Medium;
  font-weight: 600;
  text-align: left;
}
.detail-box .tit {
  text-align: left;
  font-size: 24px;
  font-family: SourceHanSansCN-Medium;
  margin-top: 20px;
  margin-bottom: 20px;
  color: #18181b;
}
.detail-box p {
  margin: 0;
  font-size: 16px;
  text-align: left;
}
</style>
